import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Selector.css';

/**
 * Компонент для отрисовки номера ветки на схеме
 * может быть круглой или прямоугольной формы
 */
export function Selector(_ref) {
  var color = _ref.color,
      rect = _ref.rect,
      text = _ref.text,
      type = _ref.type,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onClick,
    className: clsx(styles['selector'], type === 'ELLIPSE' && styles['selector_ellipse']),
    "data-testid": "line-selector",
    style: {
      width: rect.w,
      height: rect.h,
      backgroundColor: color,
      fontSize: "".concat(text.size, "px"),
      color: text.color,
      left: rect.x,
      top: rect.y
    }
  }, text.value);
}